import { Component, OnInit } from '@angular/core';
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { LockerService } from '../../../../shared/services/pubServices/lockers.service';
import { FileLocker } from 'src/app/models/pubModel/contentlocker.model';
import { Page, PageClass } from '../../../../shared/filters/filters';
import { ToastrService } from 'ngx-toastr';

declare var require
const Swal = require('sweetalert2')

@Component({
  selector: 'pub-fileslist-component',
  templateUrl: './files-list.html',
  styleUrls: ['./files-list.scss']
})

export class fileListComponent implements OnInit {
  public url: any;

  imageDomain: string[] = [ "./assets/images/domain/fileskeep.jpg", 
                      "./assets/images/domain/filesstorm.jpg", 
                      "./assets/images/domain/filescloud.jpg",                       
                      "./assets/images/domain/fileston.jpg"];

  filesData: any;
  selected : any[] = [];
  currentFile = new FileLocker();
  currentFileId: any;
  offsetNumber: number;
  page = new Page();
  sendpage = new PageClass();
  pageSizeDefinition = 20;

  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  constructor(private lockerService: LockerService, private toastrService: ToastrService) {
    this.page.pageNumber = 1;
    this.page.size = this.pageSizeDefinition;

    this.currentFile.fileLockerFileName = "";
    this.currentFile.alias = "";
    this.currentFile.leads = 1;
    this.currentFile.redirection = "";
    this.currentFile.domain = 1;
  }

  ngOnInit() {
    this.setPage({  offset: 0 });
  }

  setPage(pageInfo){
    this.sendpage.pageNumber = pageInfo.offset+1;
    this.sendpage.pageSize = this.pageSizeDefinition;

    this.lockerService.getAllFileLocker(this.sendpage)
    .subscribe(
      data => {
      this.page.totalElements = data.totalRecords;
      this.page.totalPages = data.totalPages;
      this.page.pageNumber = data.pageNumber-1;

      
      this.filesData = data.data;
      console.log("FILES: ", this.filesData);


      this.selected = [this.filesData[0]];
      this.currentFileId = this.filesData[0].lockerId;
      this.currentFile.fileLockerFileName = this.filesData[0].lockerFileName;
      this.currentFile.alias = this.filesData[0].alias;
      this.currentFile.leads = this.filesData[0].leads;
      this.currentFile.redirection = this.filesData[0].redirection;
      this.currentFile.domain = this.filesData[0].domain.id;
      },
      error => {
        console.log(error);
      });

  }

  onSelect({ selected }) {
    console.log("SELECTED DOMAIN: ", this.selected[0].domain);
    this.currentFileId = this.selected[0].lockerId;
    this.currentFile.fileLockerFileName = this.selected[0].lockerFileName;
    this.currentFile.alias = this.selected[0].alias;
    this.currentFile.leads = this.selected[0].leads;
    this.currentFile.redirection = this.selected[0].redirection;
    this.currentFile.domain = this.selected[0].domain.id;
  }

  onUpdate(){
    this.currentFile.domain = Number(this.currentFile.domain);

    this.lockerService.updateFileLocker( this.currentFileId, this.currentFile)
    .subscribe(
      data => {
        this.toastrService.success('File locker data updated.', 'Success !');
        this.setPage({  offset: 0 });
      },
      error => {
        console.log(error);
        this.toastrService.error('Update data failed.', 'Error !');
      });
  }

  onAdd(){
    this.currentFile.domain = Number(this.currentFile.domain);

    this.lockerService.newFileLocker(this.currentFile)
    .subscribe(
      data => {
        this.toastrService.success('New File locker created.', 'Success !');
        this.setPage({  offset: 0 });
      },
      error => {
        console.log(error);
        this.toastrService.error('Create data failed.', 'Error !');
      });
  }

  onDelete(){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {

        this.lockerService.deleteFileLocker(this.selected[0].lockerId)
        .subscribe(
          response => {
            Swal.fire(
            'Deleted!',
            'Your gateway has been deleted.',
            'success'
            )
            this.setPage({ offset: 0 });
          },
          error => {
            console.log(error);
          });
      }
    })
  }


  onDomain(){
      Swal.fire({ width: 1800, confirmButtonText: "Close", imageUrl: this.imageDomain[this.currentFile.domain-1], imageWidth: 1800, imageHeight: 800, imageAlt: "Custom image" })
  }

  }
